import axios from 'axios'


export default {
    getBannerDataSource(params){
        return axios.get('/banner/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getBannerbyID(id){
        return axios.get('/banner/' + id)
            .then(response => {
                return response.data
            })
    },
    createBanner(formdata){
        return axios.post('/banner', formdata)
            .then(response => {
                return response.data
            })
    },
    updateBanner(id,formdata){
        return axios.post('/banner/' + id + '/update', formdata  )
            .then(response => {
                return response.data
            })
    },
    deactivateBanner(id){
        return axios.put('/banner/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateBanner(id){
        return axios.put('/banner/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    updateBGImage(id,formData){
        return axios.post('/banner/' + id + '/update_bgimage', formData)
            .then(response => {
                return response.data
            })
    },

}